import { IFiltersState } from "src/rematch/interfaces/states/IFiltersState";
import { QUERYSTRING_FILTER_PART } from "src/backend/constants/common";
import { addQueryParameter } from "src/backend/helpers/urlHelper";
import { IFilter, isOwnPropertyFilter, IOwnPropertyFilter, IMfilesPropertyFilter, IQuickFilter, IFilterGroup, FilterGroupConditionEnum } from "src/backend/interfaces/filters/IFilter";
import { uniqueId } from "lodash";

interface IUrlFilter {
  n?: string;
  o?: number;
  p?: string | number;
  u?: number;
  v?: string;
}

interface IUrlRootFilter {
  q?: string;
  f?: IUrlFilter[];
  t?: IUrlFilter;
}

function filterToUrlFilter(filter: IFilter): IUrlFilter {
  const ret: IUrlFilter = {
    n: filter.name,
    o: filter.operator,
    v: filter.value,
    u: filter.ownerId
  };
  const isOwn = isOwnPropertyFilter(filter);
  if(isOwn) {
    const ownPanelFilter = filter as IOwnPropertyFilter;
    ret.p = ownPanelFilter?.ownPropertyName;
  } else {
    const mfPanelFilter = filter as IMfilesPropertyFilter;
    ret.p = mfPanelFilter?.propertyId;
  }
  return ret;
}


function filterGroupToUrlFilter(filterGroup: IFilterGroup): IUrlFilter[] {
  
  let urlFiltersArray = [];

  for (let f of filterGroup.filters ) {
    urlFiltersArray.push( filterToUrlFilter(f) );
  }
  
  return urlFiltersArray;
}

function urlFilterToFilter(filter: IUrlFilter): IFilter {
  const isOwn = typeof filter.p === 'string';
  if(isOwn) {
    const ownFilter: IOwnPropertyFilter = {
      name: filter.n,
      ownPropertyName: filter.p.toString(),
      operator: filter.o,
      ownerId: filter.u,
      value: filter.v,
    };
    return ownFilter;
  } else {
    const mfFilter: IMfilesPropertyFilter = {
      name: filter.n,
      propertyId: Number(filter.p),
      operator: filter.o,
      ownerId: filter.u,
      value: filter.v,
    };
    return mfFilter;
  }
}

function urlFilterToFilterGroup(urlFilter: IUrlFilter): IFilterGroup {
  const filter = urlFilterToFilter(urlFilter);
  return {
    name: uniqueId('url-filter'),
    conditionType: FilterGroupConditionEnum.AND,
    filters: [ filter ]
  }
}

// TODO convert filterGroup stuff to UrlFilter
export function setUrlFilter(filters: IFiltersState): void {
  const ret: IUrlRootFilter[] = [];
  let filterHasValue = false;
  for(let viewIndex = 0; viewIndex < filters.quickFilters.length; viewIndex++ ) {
    const filter: IUrlRootFilter = {};
    const quickFilter = filters.quickFilters[viewIndex]?.value ?? '';
    if(quickFilter.length) {
      filter.q = quickFilter;
      filterHasValue = true;
    }
    const enabledPanelFilters = filters.enabledPanelFilters[viewIndex] ?? [];
    const panelFilters = filters.panelFilters[viewIndex] ?? [];
    for(const enabledFilterId of enabledPanelFilters) {
      const panelFilter = panelFilters[enabledFilterId];
      if(panelFilter) {
        if(!filter.f) {
          filter.f = [];
        }

        // TODO fix
        // filter.f.push(filterToUrlFilter(panelFilter));
        filter.f.push(filterToUrlFilter(null));
        filterHasValue = true;
      }
    }
    const temporaryFilterGroup = filters.temporaryFilters[viewIndex];
    if(temporaryFilterGroup) {
      // TODO fix
      // filter.t = filterGroupToUrlFilter(temporaryFilterGroup);
      filter.t = filterToUrlFilter(null);
      filterHasValue = true;
    }
    ret.push(filter);
  }

  const jsonValue = JSON.stringify(ret);
  const b64Value = window.btoa(jsonValue);
  window.history.replaceState({}, "", addQueryParameter(window.location.href, QUERYSTRING_FILTER_PART, filterHasValue ? b64Value : null));
}

export function applyUrlFilter(filterParam: string, filterGroups: IFilterGroup[][]): IFiltersState {

  const jsonValue = window.atob(filterParam);
  const urlFilters = JSON.parse(jsonValue) as IUrlRootFilter[];

  const panelFilters        : IFilterGroup[][] = [];
  const temporaryFilters    : IFilterGroup[]   = [];
  const enabledPanelFilters : number[][]       = [];
  const quickFilters        : IQuickFilter[]   = [];

  for(let viewIndex = 0; viewIndex < urlFilters.length; viewIndex++) {
    const urlFilter        = urlFilters[viewIndex];
    const viewFilterGroups = filterGroups[viewIndex] ?? [];

    const enabledFilters: number[] = [];

    if(urlFilter.f) {
      for(const uf of urlFilter.f) {
        const f = urlFilterToFilterGroup(uf);
        let filterFound = false;
        let i = 0;
        for(const vfg of viewFilterGroups) {
          for ( const vf of vfg.filters ) {
            // TODO: check comparison between 2 arrays
            /* 
            if(f.ownerId === vf.ownerId && f.name === vf.name && f.operator === vf.operator && f.value === vf.value) {
              enabledFilters.push(i);
              filterFound = true;
            } */
            i++;
          }
        }
        if(!filterFound) {
          f.ownerId = -1;
          viewFilterGroups.push(f);
          enabledFilters.push(i);
        }
      }
    }

    quickFilters[viewIndex] = { value: urlFilter.q ?? '' };
    panelFilters[viewIndex] = viewFilterGroups;
    temporaryFilters[viewIndex] = urlFilter.t ? urlFilterToFilterGroup(urlFilter.t) : null;
    enabledPanelFilters[viewIndex] = enabledFilters;
  }

  const ret: IFiltersState = {
    staticFilters: null,
    panelFilters: panelFilters,
    temporaryFilters: temporaryFilters,
    enabledPanelFilters: enabledPanelFilters,
    quickFilters: quickFilters
  };
  return ret;
}